import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {pinCommentMutation} from './__generated__/pinCommentMutation.graphql'

export function pinCommentMutation({
  environment,
  input: {id},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {id: string}
  onCompleted?: () => void
  onError?: (error?: Error) => void
}) {
  return commitMutation<pinCommentMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation pinCommentMutation($input: PinIssueCommentInput!) @raw_response_type {
        pinIssueComment(input: $input) {
          clientMutationId
          issueComment {
            id
            isPinned
          }
        }
      }
    `,
    variables: {
      input: {issueCommentId: id},
    },
    optimisticResponse: {
      pinIssueComment: {
        clientMutationId: '',
        issueComment: {
          id,
          isPinned: true,
        },
      },
    },
    onCompleted: response => {
      if (response.pinIssueComment === null) {
        onError?.()
      } else {
        onCompleted?.()
      }
    },
    onError: error => onError?.(error),
  })
}
